import { Action } from '@ngrx/store';
import { Lookup } from '../../../vas/business-objects/lookup/lookup.model';

export const DESTROY = '[Text Control Mobile Modal] Destroy';
export const INIT = '[Text Control Mobile Modal] Init';
export const INIT_SUCCESS = '[Text Control Mobile Modal] Init Success';
export const INIT_FAIL = '[Text Control Mobile Modal] Init Fail';
export const SET_SEARCH_TERM = '[Text Control Mobile Modal] Set Search Term';

export class DestroyAction implements Action {
    readonly type = DESTROY;
}

export class InitAction implements Action {
    readonly type = INIT;

    constructor(public payload: {lookupTypeId: string}) {
    }
}

export class InitSuccessAction implements Action {
    readonly type = INIT_SUCCESS;

    constructor(public payload: {lookups: Array<Lookup>}) {
    }
}

export class InitFailAction implements Action {
    readonly type = INIT_FAIL;

    constructor(public payload: {error: Error}) {
    }
}

export class SetSearchTermAction implements Action {
    readonly type = SET_SEARCH_TERM;

    constructor(public payload: {searchTerm: string}) {
    }
}

export type Actions
    = DestroyAction
    | InitAction
    | InitSuccessAction
    | InitFailAction
    | SetSearchTermAction
    ;



// WEBPACK FOOTER //
// ./src/app/modals-popovers/text-control-mobile-modal/text-control-mobile-modal.actions.ts